import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, FieldArray, propTypes, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'
import DropdownList from 'react-select';
import { Button, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import cssClasses from './rules.css';
import { customStylesSplit400, customStylesSplit550 } from '../UI/select-styles';
import { OptionAccount, OptionGst, OptionCustomer } from '../UI/select';
import { PERCENTAGEANDAMOUNT, PERCENTAGE } from './constants';
import { required, maxLength50, normalizeMax8, normalizeAmount, normalizePercent } from '../Common/Validation';

const ruleTextOptions = [{ value: "All", label: 'All of these words' }, { value: "Any", label: 'Any of these words' }, { value: "Contains", label: 'Contains' }, { value: "Exact", label: 'This exact wording' }];
const ruleAmountOptions = [{ value: 'LessThan', label: 'Less than' }, { value: 'GreaterThan', label: 'Greater than' }, { value: 'Equal', label: 'Equal to' }];
// let percentageTotal = 0;

const DislplayErrors = ({ meta: { touched, error } }) => (
  <div>
    {touched && (error && <div className={cssClasses.error_label}><i className={cssClasses.greyBG}>{error}</i></div>)}
  </div>
);

const renderAmount = ({ input, change, placeholder, transactionAmount, meta: { touched, error } }) => {
  const percentSplit = (input, totalAmount) => (input.value && !isNaN(input.value)) ? (Math.round((input.value / totalAmount * 100) * 10000) / 10000) : '';
  return (
    <div className={cssClasses.inputWrapper}>
      <span className={cssClasses.inputGroupAddon}>$</span>
      <input
        {...input}
        className={[cssClasses.formControl, cssClasses.fcGroup, cssClasses.fcLeft].join(' ')}
        type="text"
        placeholder={placeholder}
        onChange={value => {
          input.onChange(value);
          const percent = percentSplit(value.target, transactionAmount);
          change(input.name.replace('Amount', 'Percentage'), percent ? percent.toFixed(2) : '');
        }}
      />
      {touched && (error && <div className={cssClasses.admin_label}><i className={cssClasses.redBG}>{error}</i></div>)}
    </div>
  )
};

const renderPercentage = ({ input, change, placeholder, transactionAmount, meta: { touched, error } }) => {
  const amountSplit = (target, totalAmount) => {
    const percentage = target.value;
    const isPercentageNumber = percentage && !isNaN(parseFloat(percentage)) && isFinite(percentage);
    const newPercentage = (percentage <= 100 && percentage >= 0) ? percentage : input.value;
    return isPercentageNumber ? (Math.round(((newPercentage) * totalAmount / 100) * 100) / 100).toFixed(2) : '';
  }
  return (
    <div className={cssClasses.inputWrapper}>
      <input
        {...input}
        className={[cssClasses.formControl, cssClasses.fcGroup, cssClasses.fcRight].join(' ')}
        type="text"
        placeholder={placeholder}
        onChange={(value) => {
          input.onChange(value);
          change(input.name.replace('Percentage', 'Amount'), amountSplit(value.target, transactionAmount));
        }} />
      {touched && (error && <div className={cssClasses.admin_label}><i className={cssClasses.redBG}>{error}</i></div>)}
      <div className={cssClasses.inputGroupAddon}>%</div>
    </div>
  )
};

const renderField = ({ input, placeholder, meta: { touched, error } }) => (
  <div className={cssClasses.errorTagRight}>
    <input {...input} className={cssClasses.formControl} type="text" placeholder={placeholder} />
    {touched && (error && <div className={cssClasses.admin_label}><i className={cssClasses.redBG}>{error}</i></div>)}
  </div>
);

const renderMonyInOut = ({ input, ...rest }) => {
  return (
    <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} {...input} {...rest}>
      <FormControlLabel className={cssClasses.width165} value="1" control={<Radio />} label="Money In" />
      <FormControlLabel className={cssClasses.width165} value="0" control={<Radio />} label="Money Out" />
    </RadioGroup>
  )
};

const renderAllocateBy = ({ input, ...rest, change }) => {
  if (!input.value) { input.value = "percentage" }
  return (
    <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} {...input} {...rest}>
      <FormControlLabel className={cssClasses.width165} value="percentage" control={<Radio onChange={() => change("Allocation", [{}])} />} label="Percentage Only" />
      <FormControlLabel className={cssClasses.width210} value={PERCENTAGEANDAMOUNT} control={<Radio />} label="Amount & Percentage" />
    </RadioGroup>
  )
};

const renderBasicSelect = ({ input, options, placeholder, ...rest }) => (
  <div>
    <DropdownList
      {...input} {...rest} isClearable
      components={{ Option: OptionCustomer }}
      isOptionDisabled={(option) => option.isActive === false}
      options={options}
      placeholder={placeholder}
      value={options.find(item => item.value === input.value)}
      onBlur={() => input.onBlur()}
      menuPlacement="top"
    />
  </div>
);

const renderSelect = ({ input, label, options, change, ...rest }) => (
  <div>
    <DropdownList
      isClearable {...input} {...rest}
      options={options}
      value={options.find(item => item.value === input.value)}
      placeholder="Anything"
      onChange={(value) => {
        input.onChange(value);
        if (value && value.value === 'Equal') change('Remainder', [{}]);
      }}
      onBlur={() => input.change}
      menuPlacement="auto"
    />
  </div>
);

const renderSelectAcc = ({ input, ...rest, options, change, meta: { touched, error }, isR1, isRah }) => (
  <div>
    <DropdownList isClearable {...input} {...rest}
      components={{ Option: OptionAccount }}
      menuPlacement="top"
      placeholder="Account"
      isOptionDisabled={(option) => option.isActive === false}
      styles={customStylesSplit550}
      value={options.find(item => item.value === input.value)}
      onChange={(value) => {
        if (value) {
          change(input.name.replace('AccountCode', 'TaxCode'), value.defaultTaxCode);
          input.onChange(value);
        }
      }}
      onBlur={() => input.change}
      onKeyDown={(e) => {
        const key = e.key;
        const element = e.target;
        if (!isR1 && !isRah && !isNaN(key) && element.value.length === 3 && key !== '/') {
          const accCode = element.value + '/';
          var select_input_field = element.parentElement.querySelector('input[type=text]');
          select_input_field.value = accCode;
        }
      }} />
    {touched && (error && <div className={[cssClasses.admin_label, cssClasses.textRight, cssClasses.margin_top_quarter].join(' ')}><i className={cssClasses.redBG}>{error}</i></div>)}
  </div>
);

const renderSelectGST = ({ input, ...rest, options, meta: { touched, error } }) => (
  <div>
    <DropdownList
      isClearable {...input} {...rest}
      onBlur={() => input.onBlur()}
      isOptionDisabled={(option) => option.isActive === false}
      placeholder="Tax Code"
      value={options.find(item => item.value === input.value)}
      formatOptionLabel={(option) => option.value}
      components={{ Option: OptionGst }}
      menuPlacement="top"
      styles={customStylesSplit400}
    />
    {touched && (error && <div className={[cssClasses.admin_label, cssClasses.textRight, cssClasses.margin_top_quarter].join(' ')}><i className={cssClasses.redBG}>{error}</i></div>)}
  </div>
);

const validate = values => {
  const errors = {};
  if (Object.entries(values).length === 0)
    return;
  // const accountCodes = values.Allocation.map(item => item.AccountCode);
  const isEqualTo = values.amountOperator && (values.amountOperator === 'Equal' || values.amountOperator.value === 'Equal');
  const isAllocationByPercent = values.allocateBy === PERCENTAGE;
  const isAllocationByPercentAndAmount = values.allocateBy === PERCENTAGEANDAMOUNT;
  const isAllocationPercent100 = values.Allocation && values.Allocation.reduce((percentage, item) => percentage + (item.Percentage ? item.Percentage * 1 : 0), 0) === 100;
  const isAllocationSumTransactionAmount = values.Allocation && values.Allocation.reduce((amount, item) => amount + (item.Amount ? item.Amount * 1 : 0), 0) == values.transactionAmount;
  const isRemainderPercent100 = values.Remainder && values.Remainder.reduce((percentage, item) => percentage + (item.Percentage ? item.Percentage * 1 : 0), 0) === 100;
  const isAllocationEmpty = (isEqualTo || isAllocationByPercentAndAmount) && values.Allocation && values.Allocation.find(item => (isNaN(item.Amount) || item.Amount === 0));
  const isRemainderEmpty = !isEqualTo && values.Remainder && values.Remainder.find(item => (isNaN(item.Percentage) || item.Percentage === 0));
  if ((values.descriptionOperator) && !values.transactionDescription) {
    errors.transactionDescription = 'Required';
  }

  if ((values.amountOperator) && !values.transactionAmount) {
    errors.transactionAmount = 'Required';
  }

  if (!values.descriptionOperator && !values.amountOperator && !values.referenceOperator && !values.typeOperator) {
    errors.DislplayErrors = 'A match on reference, description, type or amount is required';
  } else if (!isEqualTo && !isRemainderPercent100) {
    errors.DislplayErrors = 'The percentages in your remainder (%) must add up to 100%';
    if (isAllocationByPercent) errors.DislplayErrors = 'The percentages in your allocation must add up to 100%';
    // } else if (accountCodes.some((item, index) => accountCodes.indexOf(item) !== index)) {
    //   errors.DislplayErrors = 'Duplicate accounts in your allocation are not allowed';
  } else if (isEqualTo && !(isAllocationPercent100 || isAllocationSumTransactionAmount)) {
    errors.DislplayErrors = 'The amount in your allocation must add up to the rule amount';
  } else if (isAllocationEmpty) {
    errors.DislplayErrors = 'Every allocation should have amount';
  } else if (isRemainderEmpty) {
    errors.DislplayErrors = 'Every allocation should have percentage';
    if (isAllocationByPercentAndAmount) errors.DislplayErrors = 'Every remainder (%) should have percentage';
  }
  return errors;
}

const renderButton = (fields, unallocated, transactionAmount) => (
  <Button className={cssClasses.textRight} type="button" variant="contained" color="secondary" onClick={() => {
    const percentage = Math.round((unallocated / transactionAmount) * 10000000) / 100000 || 0;
    return fields.push({ Percentage: percentage.toFixed(2), Amount: (transactionAmount * (percentage / 100)).toFixed(2) });
  }}>Add New Row</Button>
)

const renderAllocation = ({ fields, transactionCodes, change, transactionAmount, classification, contacts, MoneyInOut, isRah, isR1, isEqualTo, taxTracking, isCredit }) => {
  // if (!fields.getAll()) fields.push({});
  // percentageTotal = fields.getAll().reduce((total, row) => total + row.Percentage*1 || 0, 0);
  const taxSale = transactionCodes.taxCodes.filter((item) => item.isSales);
  const taxPurchase = transactionCodes.taxCodes.filter((item) => item.isPurchase);

  const allFields = fields.getAll();
  const tempAmount = allFields ? Math.round((transactionAmount - allFields.reduce((sum, value) => {
    sum += value.Amount * 1 || 0;
    return sum;
  }, 0)) * 100) / 100 : 0;
  const unallocated = isNaN(tempAmount) ? transactionAmount : tempAmount;

  return (
    <div>
      <div className={cssClasses.updateRuleRowContainer}>
        <div className={[cssClasses.updateAllocationMedium, cssClasses.ml2].join(' ')}>Amount</div>
        {isEqualTo && <div className={cssClasses.updateAllocationMedium}>%</div>}
        <div className={cssClasses.updateAllocationLarge}>Account</div>
        {taxTracking && <div className={cssClasses.updateAllocationMedium}>Tax Code</div>}
        <div className={cssClasses.updateAllocationLarge}>Description</div>
      </div>

      {fields.map((rule, index) => (
        <div key={index} className={cssClasses.allocationContainer}>
          <div className={cssClasses.allocationRow1}>
            <div className={cssClasses.updateAllocationMedium}><Field name={`${rule}.Amount`} type="text" component={renderAmount} transactionAmount={transactionAmount} normalize={normalizeAmount} change={change} /></div>
            {isEqualTo && <div className={cssClasses.updateAllocationMedium}><Field name={`${rule}.Percentage`} type="text" component={renderPercentage} transactionAmount={transactionAmount} normalize={normalizePercent} change={change} /></div>}
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.AccountCode`} type="text" isR1={isR1} isRah={isRah} component={renderSelectAcc} options={transactionCodes.chart} validate={required} change={change} /></div>
            {taxTracking && <div className={cssClasses.updateAllocationMedium}><Field name={`${rule}.TaxCode`} type="text" component={renderSelectGST} options={MoneyInOut === "0" || isCredit ? taxPurchase : taxSale} /></div>}
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.Description`} type="text" component={renderField} placeholder="Description" /></div>
            {fields.length > 1 && <div onClick={() => fields.remove(index)}><i className="fas fa-times"></i></div>}
          </div>
          {isRah && <div className={cssClasses.allocationRow1}>
            {isEqualTo && <div className={cssClasses.updateAllocationMedium}></div>}
            <div className={cssClasses.updateAllocationMedium}></div>
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.Classification`} type="text" component={renderBasicSelect} options={classification} placeholder="Classification" /></div>
            <div className={cssClasses.contacWidth}><Field name={`${rule}.Contact`} type="text" component={renderBasicSelect} options={contacts} placeholder="Contact" /></div>
          </div>}
        </div>
      ))}
      <div className={cssClasses.rightAlign}>
        <span className={cssClasses.ml35}>{renderButton(fields, unallocated, transactionAmount)}</span>
      </div>
    </div>
  );
}

const renderRemainder = ({ fields, transactionCodes, change, transactionAmount, classification, contacts, MoneyInOut, isRah, isR1, taxTracking, isCredit }) => {
  const taxSale = transactionCodes.taxCodes.filter((item) => item.isSales);
  const taxPurchase = transactionCodes.taxCodes.filter((item) => item.isPurchase);

  const allFields = fields.getAll();
  const tempAmount = allFields ? Math.round((transactionAmount - allFields.reduce((sum, value) => {
    sum += value.Amount * 1 || 0;
    return sum;
  }, 0)) * 100) / 100 : 0;

  const unallocated = isNaN(tempAmount) ? transactionAmount : tempAmount;

  return (
    <div>
      <div className={cssClasses.updateRuleRowContainer}>
        <div className={cssClasses.updateAllocationMedium}>%</div>
        <div className={cssClasses.updateAllocationLarge}>Account</div>
        {taxTracking && <div className={cssClasses.updateAllocationMedium}>Tax Code</div>}
        <div className={cssClasses.updateAllocationLarge}>Description</div>
      </div>

      {fields.map((rule, index) => (
        <div key={index} className={cssClasses.allocationContainer}>
          <div className={cssClasses.allocationRow1}>
            <div className={cssClasses.updateAllocationMedium}><Field name={`${rule}.Percentage`} type="text" component={renderPercentage} transactionAmount={transactionAmount} normalize={normalizePercent} change={change} /></div>
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.AccountCode`} type="text" isR1={isR1} isRah={isRah} component={renderSelectAcc} options={transactionCodes.chart} validate={required} change={change} /></div>
            {taxTracking && <div className={cssClasses.updateAllocationMedium}><Field name={`${rule}.TaxCode`} type="text" component={renderSelectGST} options={MoneyInOut === "0" || isCredit ? taxPurchase : taxSale} /></div>}
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.Description`} type="text" component={renderField} placeholder="Description" /></div>
            {fields.length > 1 && <div onClick={() => fields.remove(index)}><i className="fas fa-times"></i></div>}
          </div>
          {isRah && <div className={cssClasses.allocationRow1}>
            <div className={cssClasses.updateAllocationMedium}></div>
            <div className={cssClasses.updateAllocationLarge}><Field name={`${rule}.Classification`} type="text" component={renderBasicSelect} options={classification} placeholder="Classification" /></div>
            <div className={cssClasses.contacWidth}><Field name={`${rule}.Contact`} type="text" component={renderBasicSelect} options={contacts} placeholder="Contact" /></div>
          </div>}
        </div>
      ))}
      <div className={cssClasses.rightAlign}>
        <span className={cssClasses.ml35}>{renderButton(fields, unallocated, transactionAmount)}</span>
      </div>
    </div>
  );
}

let UpdateRuleForm = (props) => {
  const { handleSubmit, isSubmitting, onCancel, change, transactionCodes, ruleValues, switchRule, initialValues, pristine, classification, contacts, isRah, isR1, amountOperator, transactionAmount, taxTracking, MoneyInOut, allocateBy, isCredit } = props;
  const isEqualTo = (amountOperator === 'Equal') || (amountOperator && amountOperator.value === 'Equal');
  const allocateByPercentAndAmount = (allocateBy === PERCENTAGEANDAMOUNT);
  const percentageName = allocateByPercentAndAmount ? 'Remainder (%)' : null;
  const chart = transactionCodes.chart.filter(item => item.value !== 'split' && item.value !== 'match');

  return (
    <form onSubmit={handleSubmit}>
      <div className={[cssClasses.updateRuleRowContainer, cssClasses.sharedBackground].join(' ')}>
        <div className={cssClasses.width150}>Rule Title:</div>
        <div className={cssClasses.updateDefintitionText}><Field name="Description" type="text" component={renderField} validate={[required, maxLength50]} /></div>
        {ruleValues.EffectiveTo && <div>
          Rule <span className={cssClasses.redColour}>not active</span>
          {ruleValues.NewRuleId && <span> superseded by <span className={cssClasses.followRule} onClick={() => switchRule(initialValues.NewRuleId)}>this rule</span></span>}</div>}
      </div>

      <div className={cssClasses.updateRuleContainer}>
        <h5 className={cssClasses.mb0}>Definition</h5>
        <div className={cssClasses.updateRuleRowContainer}>
          <div className={cssClasses.width150}>Applies To:</div>
          <Field name="MoneyInOut" type="text" component={renderMonyInOut} />
        </div>

        <div className={cssClasses.updateRuleRowContainer}>
          <div className={cssClasses.width150}>Ref:</div>
          <div className={cssClasses.updateDefinitionSelector}><Field name="referenceOperator" type="text" component={renderSelect} options={ruleTextOptions} change={change} /></div>
          <div className={cssClasses.updateDefintitionText}><Field name="transactionReference" type="text" component={renderField} /></div>
        </div>

        <div className={cssClasses.updateRuleRowContainer}>
          <div className={cssClasses.width150}>Type:</div>
          <div className={cssClasses.updateDefinitionSelector}><Field name="typeOperator" type="text" component={renderSelect} options={ruleTextOptions} change={change} /></div>
          <div className={cssClasses.updateDefintitionText}><Field name="transactionType" type="text" component={renderField} /></div>
        </div>

        <div className={cssClasses.updateRuleRowContainer}>
          <div className={cssClasses.width150}>Description:</div>
          <div className={cssClasses.updateDefinitionSelector}><Field name="descriptionOperator" type="text" component={renderSelect} options={ruleTextOptions} change={change} /></div>
          <div className={cssClasses.updateDefintitionText}><Field name="transactionDescription" type="text" component={renderField} /></div>
        </div>

        <div className={[cssClasses.updateRuleRowContainer, cssClasses.mb15].join(' ')}>
          <div className={cssClasses.width150}>Amount:</div>
          <div className={cssClasses.updateDefinitionSelector}><Field name="amountOperator" type="text" component={renderSelect} options={ruleAmountOptions} change={change} /></div>
          <div className={cssClasses.updateDefintitionText}><Field name="transactionAmount" type="text" component={renderField} normalize={normalizeMax8} /></div>
        </div>

        <h5 className={cssClasses.mb5}>Allocation</h5>

        {!isEqualTo && <div className={cssClasses.updateRuleRowContainer}>
          <div className={cssClasses.width150}>Allocate by:</div>
          <Field name="allocateBy" type="text" component={renderAllocateBy} change={change} />
        </div>}

        {(isEqualTo || allocateByPercentAndAmount) && <React.Fragment>
          <div>
            {!isEqualTo && <h5 className={cssClasses.mb5}>Fixed Amount</h5>}
            <FieldArray
              name="Allocation"
              change={change}
              transactionCodes={{ chart, taxCodes: transactionCodes.taxCodes }}
              component={renderAllocation}
              transactionAmount={transactionAmount}
              classification={classification}
              contacts={contacts}
              MoneyInOut={MoneyInOut}
              isEqualTo={isEqualTo}
              isRah={isRah}
              isR1={isR1}
              taxTracking={taxTracking}
              isCredit={isCredit} /></div>
        </React.Fragment>}

        {!isEqualTo && <React.Fragment>
          <h5 className={cssClasses.mb5}>{percentageName}</h5>
          <div>
            <FieldArray
              name="Remainder"
              change={change}
              transactionCodes={{ chart, taxCodes: transactionCodes.taxCodes }}
              component={renderRemainder}
              transactionAmount={transactionAmount}
              classification={classification}
              contacts={contacts}
              MoneyInOut={MoneyInOut}
              isRah={isRah}
              isR1={isR1}
              taxTracking={taxTracking}
              isCredit={isCredit} /></div>
        </React.Fragment>}

        {!isEqualTo && allocateByPercentAndAmount &&
          <div className={[cssClasses.rowContainer, cssClasses.disclaimer].join(' ')}>* Fixed amounts are applied first, then the percentages are applied to any remainder.</div>}

      </div>
      <div>
      </div>

      <hr />
      <div className={cssClasses.ruleFooter}>
        {!ruleValues.EffectiveTo && <Button type="submit" variant="contained" color="primary" disabled={isSubmitting || pristine}>Save Rule</Button>}
        <Button type="button" variant="contained" onClick={onCancel}>Close</Button>
        <Field name="DislplayErrors" type="text" component={DislplayErrors} />
        {false && <span className={cssClasses.mutedMessage}>Percentage value not valid (Should total 100)</span>}
      </div>
    </form>
  );
};

UpdateRuleForm.propTypes = {
  ...propTypes,

};

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired
};

UpdateRuleForm = reduxForm({
  form: 'updateRule',
  validate,
  enableReinitialize: true
})(UpdateRuleForm);

const selector = formValueSelector('updateRule')
export default UpdateRuleForm = connect(state => {
  const amountOperator = selector(state, 'amountOperator');
  const transactionAmount = selector(state, 'transactionAmount');
  const MoneyInOut = selector(state, 'MoneyInOut');
  const allocateBy = selector(state, 'allocateBy');
  return { amountOperator, transactionAmount, MoneyInOut, allocateBy };
})(UpdateRuleForm)


// WEBPACK FOOTER //
// ./src/components/Rules/UpdateRuleForm.js